import { create } from 'zustand'

import type { AuthProblem } from './claims'

/** Matriz RBAC do backend (app/core/auth.py). */
export type Role = 'finance_admin' | 'finance_writer'

export type AuthStatus =
  | 'loading'
  | 'anonymous'
  | 'authenticated'
  /** Token válido, mas o realm não emite o que a API exige. Ver preflightClaims. */
  | 'misconfigured'

interface AuthState {
  readonly status: AuthStatus
  readonly subject: string | null
  readonly tenantId: string | null
  /** Array, NÃO Set: referência estável para o shallow compare do Zustand. */
  readonly roles: readonly string[]
  readonly email: string | null
  readonly name: string | null
  readonly problems: readonly AuthProblem[]
  setAuthenticated: (p: {
    subject: string
    tenantId: string
    roles: readonly string[]
    email: string | null
    name: string | null
  }) => void
  setAnonymous: () => void
  setMisconfigured: (problems: readonly AuthProblem[]) => void
}

const vazio = {
  subject: null,
  tenantId: null,
  roles: [] as readonly string[],
  email: null,
  name: null,
  problems: [] as readonly AuthProblem[],
}

/**
 * create() em escopo de MÓDULO, nunca dentro de componente: o React Compiler
 * pode memoizar o render e uma store criada ali perderia atualizações.
 */
export const useAuthStore = create<AuthState>()((set) => ({
  status: 'loading',
  ...vazio,
  setAuthenticated: (p) => {
    set({ status: 'authenticated', ...p, problems: [] })
  },
  setAnonymous: () => {
    set({ status: 'anonymous', ...vazio })
  },
  setMisconfigured: (problems) => {
    set({ status: 'misconfigured', ...vazio, problems })
  },
}))
